export const AVAILABLE_IWEB_GRADUATE_YEARS: number[] = [2024, 2025, 2026];
